import { ProjectAnswerStatus, QuestionAnswer } from '@empathy/global/data';
import { SurveyResolvedDetail } from '@empathy/survey/base';

import { ProjectMetadata } from './project-metadata.interface';

export class SurveyAnswer {
  resolvedDetail: SurveyResolvedDetail;
  id: string;
  projectId: string;
  answers: QuestionAnswer[];
  answersJson: string | null;
  metaData: ProjectMetadata;
  answerStartDateTime: Date;
  answerCompletedDateTime: Date;
  status: ProjectAnswerStatus;
  panelMemberId: string;
  panelistName: string;
  panelistEmailAddress: string;
  timeUsed: string;
}
